<div class="ui-layout-main">
  <Transition name="mask">
    <div class="mask" v-if="$store.state.openSideBar && $store.state.isRWDBreakingPoint" @click="maskClick"></div>
  </Transition>
  <div class="header-block">
    <slot name="header"></slot>
  </div>
  <div class="layout-main-block">
    <!-- /// -->
    <div class="side-menu-block"  ref="sideBar">
      <div class="minW">
        <div class="side-menu-block_userDataRWD" v-if="$store.state.isRWDBreakingPoint ">
          <i class="icon-block">
            <iCon class="icon" iconClass="top-accounts_portrait_n"></iCon>
          </i>
          <div>{{userName}}</div>
          <div>{{email}}</div>

        </div>

          <div class="btn-block" :class="{'marginInside':$store.state.isRWDBreakingPoint}">
            <Button id="GTM__addDevice" class="btn" wd="mdlg" colors="main" :text="$t('__d7d_n17r.__addDevice')" type="border" icon="icon-add"
              @onClick="onClickBtn"></Button>
          </div>
          <ul class="side-menu-list">
            <li class="side-menu-item" v-for="(item, index) in sidemenu" :id="'GTM'+ item.gtmId">
              <a class="item-block" href="javascript:;" @click="onClickMenu(item.link, index, item.query)"
                :class="{'active': active === index}">
                <span class="icon-block">
                  <iCon :iconClass="item.icon" class="icon-item"></iCon>
                </span>
                <span class="text">{{item.text}}</span>
              </a>
            </li>
            <li class="side-menu-item rwdSub" v-for="(item, index) in sideInfo" v-if="$store.state.isRWDBreakingPoint">
              <div class="side-menu-item_flex">
                <a class="item-block moreInfo"  :class="{'sideInfoActive' : index == state.isOpen, 'hasArrow' : item.sub.length }" 
                href="javascript:;" @click="onClickSideInfo(index)">
                  <span class="icon-block" >
                    <iCon :iconClass="item.icon" class="icon-item"></iCon>
                  </span>
                  <span class="text">{{item.text}}</span>
                </a>
              </div>
              <!-- <Transition name="fadeHeight"> -->
                <div class="infoList item-block " v-if="(state.isOpen==0 || state.isOpen) && item.sub.length && state.isOpen == index" >
                  <div v-for="(e, i) in item.sub" :class="{'active': state.langSelectedIndex == i && item.id == 'language'}" @click="onClickSideInfoList(e, item.id ,i)">
                    <span class="icon-block">
                      <span class="icon-item"></span>
                    </span>
                    <span class="text">{{e.name}}</span>
                  </div>
                </div>
              <!-- </Transition> -->
            </li>
          </ul>
        <!-- </div> -->
        <div class="btm-block align-center">
          <div class="versionBlock">
            <div class="text">{{$t('__main.__version')}}</div>
            <div class="version">v.{{version}}</div>
          </div>
          <div class="text logout" v-if="$store.state.isRWDBreakingPoint" @click="logout">{{$t('__main.__logOut')}}</div>
        </div>
      </div>
    </div>
    <!-- /// -->
    <div class="layout-content-block">
      <div class="nav-bar-block">
        <div class="left-part-block">
          <a href="javascript:;" class="btn-block" @click="back" v-if="isBack">
            <iCon iconClass="icon-back" class="icon-item"></iCon>
          </a>
          <div class="page-title-block">
            <Breadcrumb :datas="breadcrumb"></Breadcrumb>
          </div>
        </div>
        <div class="right-part-block" v-if="time != ''">
          <a href="javascript:;" class="right-btn-block" @click="onClickRefresh">
            <i class="icon-block">
              <iCon iconClass="icon-refresh" class="icon-item"></iCon>
            </i>
            <span class="text">
              {{$t('__d7d_n17r.__refreshTime')}}： {{time}}
            </span>
          </a>
        </div>
        <div id="layout-extra" class="right-part-block extra">
          <Button v-if="btnIsShow" class="btn-next" @onClick="onClickPrarmeter"
            :text="$t('__a7d.__adjustParameters')"></Button>
          <!-- <slot name="extra"></slot> -->
        </div>
      </div>
      <div class="layout-detail-block" id="main-layout-content">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</div>